<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="线路" prop="circuitId">
            <el-select clearable v-model="queryParams.circuitId" placeholder="请选择线路进行查询">
              <el-option v-for="item in circuitList" :key="item.circuitId" :label="item.circuitName"
                :value="item.circuitId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型">
            <el-select clearable v-model="queryParams.type" placeholder="请选择类型">
              <el-option v-for="item in systemModelList" :key="item.dictValue" :label="item.dictLabel"
                :value="item.dictValue"></el-option>
            </el-select>
          </el-form-item>
          <div class="btn-boxs">
            <div></div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table :data="tableData" v-loading="tableLoading" border row-key="deptId" default-expand-all
        :tree-props="{ children: 'children' }" highlight-current-row max-height="447"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }">
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
          show-overflow-tooltip :width="tab.width">
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span v-if="tab.code === 'videoTime'">
              <i class="el-icon-time"></i>
              <span style="margin-left:5px">{{ scope.row.videoTime }}</span>
            </span>
            <span v-else-if="tab.code === 'lineType'">{{
              scope.row.lineType === '0' ? '单线' : scope.row.lineType === '1' ? '上行' : '下行' }}</span>
            <span v-else-if="tab.code === 'type'">{{ typeMaping[scope.row.type] }}</span>
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button type="text" @click="playVideo(scope.row)" class="update-btn">播放视频</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
          @pagination="onChangePages" />
      </div>
    </div>
    <!-- 播放视频的dialog -->
    <el-dialog title="播放视频" :visible.sync="dialogVideoVisible" width="50%">
      <video ref="myVideo" id="myVideo" style="width:100%;height:500px" :src="videoSrc" controls autoplay muted
        loop></video>
    </el-dialog>
    <!-- 修改视频信息 -->
    <el-dialog title="修改" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="线路" prop="circuitId">
          <el-select clearable v-model="form.circuitId" placeholder="请选择线路" @change="circuitChange">
            <el-option v-for="item in circuitList" :key="item.circuitId" :label="item.circuitName"
              :value="item.circuitId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行别" prop="lineType">
          <el-select clearable v-model="form.lineType" placeholder="请选择行别" @change="lineTypeChange">
            <el-option v-for="item in lineTypeList" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区站" prop="stationId" v-if="form.lineType">
          <el-select clearable v-model="form.stationId" placeholder="请选择区站">
            <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
              :value="item.stationId"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="类型">
          <el-select v-model="form.type" placeholder="请选择类型">
            <el-option label="1C" value="1"></el-option>
            <el-option label="2C" value="2"></el-option>
            <el-option label="3C" value="3"></el-option>
            <el-option label="4C" value="4"></el-option>
            <el-option label="5C" value="5"></el-option>
            <el-option label="浮冰检测" value="6"></el-option>
            <el-option label="隧道2C" value="7"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="视频时间" prop="videoTime">
          <el-date-picker v-model="form.videoTime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime" placeholder="选择视频时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="视频名称" prop="videoName">
          <el-input type="textarea" v-model="form.videoName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import { getVideoList, videoById, updeteVideo } from "@/api/document-service/video.js";
import { getComponentAll } from "@/api/data-service/unit.js";
import { getCircuitAll } from "@/api/data-service/line.js";
import { getSystemModel } from "@/api/admin-service/dictDataType.js";
import { getStationAll } from "@/api/data-service/station.js";

export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      dialogVideoVisible: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "线路", code: "circuitName", width: "" },
        { name: "区站", code: "stationName", width: "" },
        { name: "行别", code: "lineType", width: "" },
        // { name: "支柱", code: "pillarNum", width: "" },
        // { name: "部件设备", code: "componentName", width: "" },
        { name: "类型", code: "type", width: "" },
        { name: "视频时间", code: "videoTime", width: "" },
        { name: "视频名称", code: "videoName", width: "" },
        { name: "视频路径", code: "videoPath", width: "" }
      ],
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        // pillarId: 0,
        // componentId: 0,
        type: "",
        circuitId: ""
      },
      typeMaping: {
        "1": '1C',
        "2": '2C',
        "3": '3C',
        "4": '4C',
        "5": '5C',
        "6": '浮冰检测',
        "7": '隧道2C',
      },
      apparatusList: [],
      componentList: [],
      pillarList: [],
      circuitList: [],
      lineTypeList: [],
      stationList: [],
      videoSrc: "",
      systemModelList: [],
      dialogFormVisible: false,
      form: {
        circuitId: '',
        lineType: '',
        stationId: '',
        type: "",
        videoTime: "",
        videoName: "",
      },
      rules: {
        circuitId: [{ required: true, message: "请选择线路", trigger: "blur" }],
        lineType: [{ required: true, message: "请选择行别", trigger: "blur" }],
        stationId: [{ required: true, message: "请选择区站", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        videoTime: [{ required: true, message: "请选择视频时间", trigger: "blur" }],
        videoName: [{ required: true, message: "请输入视频名称", trigger: "blur" }],
      },
      formLabelWidth: '90px'
    };
  },
  mounted() {
    this.onGetDataList();
    // this.queryComponentList(); //查询部件枚举
    this.queryCircuitList();
    this.getSystemModel();
    // 监听键盘事件
    document.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    // 在组件销毁之前移除键盘事件监听
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updeteVideo(this.form).then(res => {
            if (res.data || res.code === '200') {
              this.$message.success('修改成功！' || res?.msg)
              this.onGetDataList()
              this.dialogFormVisible = false
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.dialogFormVisible = false
      this.$refs[formName].resetFields();
    },
    queryStaionList(circuitId, lineType) {
      getStationAll({
        stationName: "", //区站名称
        circuitId,
        lineType,
        ...this.pageParams
      }).then(res => {
        this.stationList = res?.data || [];
      });
    },
    lineTypeChange(val) {
      this.form.startStationId = "";
      this.form.endStationId = "";
      this.form.startStationSign = "";
      this.form.endStationSign = "";
      this.queryStaionList(this.form.circuitId, val);
    },
    circuitChange(newValue) {

      this.form.lineType = "";
      this.form.startStationId = "";
      this.form.endStationId = "";
      this.form.startStationSign = "";
      this.form.endStationSign = "";
      this.form.classify = "";
      // this.queryParams.circuitId = newValue;
      this.circuitList.forEach(item => {
        if (item.circuitId === newValue) {
          if (item.classify === '1') {
            this.form.classify = '1'
          } else {
            this.form.classify = '0'

          }

          if (item.type === "0") {
            // 说明是单线
            this.lineTypeList = [
              {
                dictLabel: "单线",
                dictValue: "0"
              }
            ];
          } else {
            this.lineTypeList = [
              {
                dictLabel: "上行",
                dictValue: "1"
              },
              {
                dictLabel: "下行",
                dictValue: "2"
              }
            ];
          }
        }

      });
    },
    updateData(row) {
      this.dialogFormVisible = true
      videoById({ id: row.videoId }).then(res => {
        if (res.code === '200') {
          const { circuitId, lineType } = res.data
          this.queryStaionList(circuitId, lineType)
          this.circuitList.forEach(item => {
            if (item.circuitId === circuitId) {
              if (item.type === "0") {
                // 说明是单线
                this.lineTypeList = [
                  {
                    dictLabel: "单线",
                    dictValue: "0"
                  }
                ];
              } else {
                this.lineTypeList = [
                  {
                    dictLabel: "上行",
                    dictValue: "1"
                  },
                  {
                    dictLabel: "下行",
                    dictValue: "2"
                  }
                ];
              }
              this.form.lineType = lineType
            }
          })
          Object.assign(this.form, res?.data)

        }

      })
    },
    getSystemModel() {
      getSystemModel({ type: "sys_model_type" }).then(res => {
        this.systemModelList = res?.data || [];
      });
    },
    handleKeydown(event) {
      const video = this.$refs.myVideo; // 获取视频元素
      switch (event.key) {
        case "Enter":
          // 按下 Enter 键，暂停或播放视频
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
          break;
        case "ArrowRight":
          video.currentTime += 1;
          break;
        case "ArrowLeft":
          video.currentTime -= 1;
          break;
      }
    },
    playVideo(row) {
      this.dialogVideoVisible = true;
      const typeMaping = {
        "1": process.env.VUE_APP_SOURCE8,
        "2": process.env.VUE_APP_SOURCE2,
        "4": process.env.VUE_APP_SOURCE4,
      };
      this.videoSrc = typeMaping[row.type] + row.videoPath;
      // 视频自动聚焦
      this.$nextTick(() => {
        const videoElement = this.$refs.myVideo;
        if (videoElement) {
          videoElement.focus(); // 聚焦视频元素
          videoElement.play();
        }
      });
    },

    queryComponentList() {
      getComponentAll({
        componentName: "",
        ...this.pageParams
      }).then(res => {
        this.componentList = res?.data || [];
      });
    },
    queryCircuitList() {
      getCircuitAll({
        circuitName: "", //线路名称
        ...this.pageParams
      }).then(res => {
        this.circuitList = res?.data || [];
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getVideoList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          this.tableData = records;
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1
      this.pageParams.pageSize = 10
      Object.keys(this.queryParams).forEach(key => {
        this.queryParams[key] = ""; // 你可以根据需要调整重置的值（例如：'' 或者 null）
      });
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
